module.exports = __webpack_public_path__ + "img/info.47763cd2.svg";